import * as types from './project.types';
import * as constants from './project.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeProject = generateStoreResourceAction<types.IProject>(constants.STORE_PROJECT);
export const clearProject = generateClearResourceAction(constants.CLEAR_PROJECT);
